export default {
    ERROR_REQUIRED: 'Polje je obavezno',
    ERROR_STRING: 'Vrednost polja nije tekts',
    ERROR_NUMBER: 'Vrednost polja nije broj',
    ERROR_BOOLEAN: 'Vrednost polja nije boolean',
    ERROR_EMAIL: 'Vrednost polja nije email',
    ERROR_MAXLENGTH: 'Vrednost polja mora biti {{criteria}} ili manje karaktera',
    ERROR_MINLENGTH: 'Vrednost polja mora biti {{criteria}} ili više karaktera',
    ERROR_MAX: 'Vrednost polja mora biti manja ili jednaka od {{criteria}}',
    ERROR_MIN: 'Vrednost polja mora biti {{criteria}} ili veća',
    ERROR_REGEX: 'Vrednost polja ne zadovoljava regex {{criteria}}',
    ERROR_LONGITUDE: 'Vrednost nije geografska dužina',
    ERROR_LATITUDE: 'Vrednost nije geografska širina',
    ERROR_POSITIVE_NUMBER: 'Vrednost polja mora biti jednaka ili veća od 1',
    ERROR_ZERO_OR_HIGER: 'Vrednost polja mora biti 0 ili veća',
    ERROR_DOMAIN: 'Vrednost nije domen',
    ERROR_ZIP_CODE: 'Vrednost nije validan poštasnki broj',
    ERROR_DISCOUNTED_PRICE: 'Pogledajte info pored polja',
    ERROR_MAX_SELECTION: 'Vrednost polja mora biti broj veći 2',
};
